export default {
  saveUserInfo(state: any, data: any) {
    state.userInfo = data;
    state.status.login = true;
    console.log(state.userInfo);
  },
};
